import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2, XCircle } from 'lucide-react';
export const WhoIsThisFor = () => {
  const positives = ['Tenés un bebé de 4 a 24 meses que se despierta más de 2 veces por noche', 'Ya probaste rutinas "de Google" que funcionaron un par de días y después fallaron', 'Querés una solución respetuosa que no implique dejar llorar a tu bebé', 'Estás agotado/a y necesitás un sistema claro, no más información contradictoria', 'Sentís que el cansancio ya está afectando tu trabajo, tu humor o tu pareja'];
  const negatives = ['No buscás un método concreto y preferís esperar a que "se resuelva solo"', 'Esperás resultados sin aplicar ningún protocolo'];
  return <section className="py-8 md:py-12 px-4 bg-navy-950" data-id="element-341">
      <div className="max-w-4xl mx-auto" data-id="element-342">
        <FadeIn data-id="element-343">
          <div className="bg-navy-900 border border-navy-700 rounded-3xl overflow-hidden shadow-2xl" data-id="element-344">
            {/* Positive Section */}
            <div className="p-6 md:p-10 border-b border-navy-800 bg-gradient-to-b from-navy-800/30 to-transparent" data-id="element-345">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-8 flex items-center" data-id="element-346">
                <CheckCircle2 className="w-8 h-8 text-green-400 mr-3 drop-shadow-[0_0_8px_rgba(74,222,128,0.3)]" data-id="element-347" />
                Este sistema es para vos si...
              </h2>
              <ul className="space-y-4" data-id="element-348">
                {positives.map((item, index) => <li key={index} className="flex items-start" data-id="element-349">
                    <span className="text-xl mr-3 flex-shrink-0 drop-shadow-md" data-id="element-350">
                      🌙
                    </span>
                    <span className="text-base md:text-lg text-gray-100 font-medium" data-id="element-351">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Negative Section */}
            <div className="p-6 md:p-10 bg-gradient-to-b from-red-950/20 to-navy-900 border-t border-red-900/20" data-id="element-352">
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-6 flex items-center" data-id="element-353">
                <XCircle className="w-7 h-7 text-red-500 mr-3 drop-shadow-[0_0_8px_rgba(239,68,68,0.3)]" data-id="element-354" />
                Este sistema NO es para vos si...
              </h3>
              <ul className="space-y-4" data-id="element-355">
                {negatives.map((item, index) => <li key={index} className="flex items-start" data-id="element-356">
                    <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(239,68,68,0.2)]" data-id="element-357" />
                    <span className="text-sm md:text-base text-gray-100 font-medium" data-id="element-358">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};